import { SponsorsData } from '@bm-js/atlascloud-shared'
import MarginOptions from './MarginOptions'
import { RightBarEditorProps } from './BulletPointsEditor'
import Input from './Input'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const SponsorEditor = ({
  content,
  setData,
}: RightBarEditorProps<SponsorsData>) => {
  const { tr } = useTr()

  return (
    <>
      <Input
        light
        label={tr(TrKey.sponsorEditorTopTextLabel)}
        type='text'
        name='topText'
        id='topText'
        value={content.data.topText}
        onChange={setData}
      />
      <MarginOptions content={content} setData={setData} topLine />
    </>
  )
}

export default SponsorEditor
